import type { VAxios } from '../../define/axios/Axios';
import {
  GetWorkCreationRes,
  NewJobParams,
  CommonJob,
  CommonDebugger,
  NewEditorsParams,
  ContentDetail,
  MyStyles,
  MyRecentStyles,
} from '../../entities/cc/common.entities';
import { CreationCommonCreateParams, CreationFileInfo } from '../../entities/cc/creations.entities';

/**
 * 内容中心接口配置
 */
export const createApi = (defHttp: VAxios) => ({
  // 提交直接生成任务
  createJob: (id, params) => {
    return defHttp.post({ url: `/aiad/creations/common/${id}/create`, params });
  },

  // 查询直接生成的任务
  getCreateJob: (id, jobId) => {
    return defHttp.get({ url: `/aiad/creations/common/${id}/create/${jobId}` });
  },

  // 生成作品
  addCreation: (params?: CreationCommonCreateParams) => {
    return defHttp.post({ url: '/aiad/creations/common', params });
  },

  deleteCreation: (id: string) => {
    return defHttp.delete({ url: `/aiad/creations/common/${id}` });
  },

  // 获取作品创作信息
  getWorkCreation: (id) => {
    return defHttp.get<GetWorkCreationRes>({
      url: `/aiad/creations/common/${id}`,
    });
  },

  // 查询商品图背景列表
  goodsBgs: () => {
    return defHttp.get({
      url: `/aiad/creations/common/bgs`,
    });
  },

  // 查询AI换模特背景列表
  modelBgs: () => {
    return defHttp.get({
      url: `/aiad/creations/common/model/bgs`,
    });
  },

  // 图像转风格pro风格列表
  draftStyles: (params: { type: string }) => {
    return defHttp.get({
      url: `/aiad/creations/common/transform/styles`,
      params,
    });
  },

  // 查询模特脸列表
  modelFaces: () => {
    return defHttp.get({
      url: `/aiad/creations/common/model/faces`,
    });
  },

  // 获取创作的所有文件
  getCreationFiles: (id, params) => {
    return defHttp.get<CreationFileInfo[]>({ url: `/aiad/common/creations/${id}/files`, params });
  },

  // 提交生成任务
  newJob: (id, params: NewJobParams) => {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/jobs`,
      params,
    });
  },

  // 查询单个任务信息
  getJob: (id, jobId) => {
    return defHttp.get<CommonJob>({
      url: `/aiad/creations/common/${id}/jobs/${jobId}`,
    });
  },

  // 修改作品图片信息
  updateWorkCreationImage: (
    id,
    params: {
      sourceId?: string | number;
      sourceType?: string;
      url?: string;
    },
  ) => {
    return defHttp.put({
      url: `/aiad/creations/common/${id}/image`,
      params,
    });
  },

  // 修改作品创作信息
  updateWorkCreation: (
    id,
    params: {
      name?: string;
    },
  ) => {
    return defHttp.put({
      url: `/aiad/creations/common/${id}`,
      params,
    });
  },

  // 标记
  mark: (id, fileId) => {
    return defHttp.put({
      url: `/aiad/creations/common/${id}/files/${fileId}/mark`,
      data: 'mark',
    });
  },

  // 取消标记
  cancelMark: (id, fileId) => {
    return defHttp.delete({
      url: `/aiad/creations/common/${id}/files/${fileId}/mark`,
    });
  },

  // 复制
  copy: (id, fileId) => {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/files/${fileId}/copy`,
    });
  },

  // 下载
  download: (id, fileId, multiple: number) => {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/files/${fileId}/download`,
      data: multiple + '',
    });
  },
  // 下载矢量
  downloadSVG: (id, fileId, format) => {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/svg/download`,
      data: {
        fileId,
        format,
      },
    });
  },

  // 获取文件详情
  getFileDetail(fileId, id) {
    return defHttp.get({
      url: `/aiad/creations/common/${id}/files/${fileId}`,
    });
  },

  // 修改生成任务
  updateWorkCreationJob: (
    id,
    params: {
      ability: string;
      debugger?: CommonDebugger;
      num?: number;
    },
  ) => {
    return defHttp.put({
      url: `/aiad/creations/common/${id}/jobs`,
      params,
    });
  },

  // 修改智能创作作品图片信息
  updateSmartImage: (
    id: string | number,
    params?: {
      sourceId: string | null;
      sourceType: string | null;
      url: string;
    },
  ) => {
    return defHttp.put({ url: `/aiad/creations/common/${id}/editor/image`, params });
  },

  // 设置通用设计案例
  toCommonCase(params: {
    creationId: string | number;
    debugger: any;
    fileId: string | number;
    image: string;
  }) {
    return defHttp.post({ url: `/aiad/cases/common`, params });
  },

  fileUpload(id, params) {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/files`,
      params,
    });
  },

  // 提交智能编辑结果
  saveEditorVersion: (id, params: NewEditorsParams) => {
    return defHttp.post<CreationFileInfo>({
      url: `/aiad/creations/common/${id}/editors`,
      params,
    });
  },

  // 保存成正式作品
  save: (id) => {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/save`,
    });
  },

  // 从内容新建作品
  templateToCreation: (id) => {
    return defHttp.post({
      url: `/aiad/creations/common/template/${id}`,
    });
  },

  // 从内容新建作品
  release: (params: {
    contentId?: string | number;
    creationId?: string | number;
    debugger?: string;
    image?: string;
    name?: string;
  }) => {
    return defHttp.post({
      url: `/aiad/creations/common/release`,
      params,
    });
  },

  // 查询精选内容详情
  getContentDetail: (params: { id: string | number }) => {
    return defHttp.get<ContentDetail>({
      url: `/aiad/creations/common/contents/${params.id}`,
      params,
    });
  },

  // 查询我最近使用的风格
  getMyRecentStyles: (params) => {
    return defHttp.get<MyRecentStyles>({
      url: `/aiad/creations/common/my-recent-styles`,
      params,
    });
  },

  // 查询我的风格
  getMyStyles: (params) => {
    return defHttp.get<MyStyles>({
      url: `/aiad/creations/common/my-styles`,
      params,
    });
  },

  // 收藏
  star: (id: string | number) => {
    return defHttp.post({
      url: `/aiad/creations/common/my-styles/${id}?`,
    });
  },

  // 取消收藏
  unStar: (id: string | number) => {
    return defHttp.delete({
      url: `/aiad/creations/common/my-styles/${id}?`,
    });
  },

  // 批量抠图
  createBatchMattingJob: (id: string | number, params) => {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/batchMatting`,
      params,
    });
  },

  // 添加任务
  addFileToBatchMattingJob: (id, workflowId, params) => {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/batchMatting/${workflowId}/jobs`,
      params,
    });
  },

  // 查询结果
  queryBatchMattingResult: (id, workflowId) => {
    return defHttp.get({
      url: `/aiad/creations/common/${id}/batchMatting/${workflowId}`,
    });
  },

  // 修改文件
  modifyFile: (id, fileId, params) => {
    return defHttp.put({
      url: `/aiad/creations/common/${id}/files/${fileId}`,
      params,
    });
  },

  // 修改文件
  downloadFiles: (
    id,
    params: {
      fileIds: (string | number)[];
    },
  ) => {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/files/download`,
      params,
    });
  },

  // sam npy数据获取
  getSamEmbedding: (url: string) => {
    const formData = new FormData();
    formData.append('url', url);
    return defHttp.post({
      url: `/aiad/creations/embedding`,
      params: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // 批量抠图下载log
  batchDownloadLog: (id, fileIds) => {
    return defHttp.post({
      url: `/aiad/creations/common/${id}/files/download`,
      params: {
        fileIds,
      },
    });
  },

  // 查询穿衣模特列表
  fittingBgs: () => {
    return defHttp.get({
      url: `/aiad/creations/common/model/fitting`,
    });
  },

  // 提示词助理
  promptAssistant: (params: {
    background?: string;
    color?: string;
    content: string;
    design?: string;
    emotion?: string;
    scene?: string;
    style?: string;
    vision?: string;
  }) => {
    return defHttp.post({
      url: `/aiad/creations/common/text/assistant`,
      params,
    });
  },

  // 模特抠图
  modelMatting: (url: string) =>
    defHttp.post({
      url: `/aiad/creations/model/matting?url=${url}`,
    }),
});
